module.exports = __webpack_public_path__ + "media/modals/img2-cc5ffa8f.svg";